import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import MasterLayout from '../AppLayout/MasterLayout';
import CollectionsAppLayout from '../AppLayout/Collections/CollectionsAppLayout';
import CollectionsTabs from '../AppLayout/Collections/CollectionsTabs';
import FollowedCollectionsEmptyState from './FollowedCollectionsEmptyState';
import { routes } from '../../constants';
import { AsyncActionStatus } from '../../actions/common.actionTypes';
import { CollectionProperties } from '../../types/AppContent';
import FollowedCollectionsList from './FollowedCollectionsList';
import useResponsivePadding from '../../utils/useResponsivePadding';
import useRouter from '../../utils/useRouter';
import FollowedCollectionsHeaderButton from './FollowedCollectionsHeaderButton';

interface FollowedCollectionsProps {
  collectionsStatus: AsyncActionStatus;
  collections:  CollectionProperties[];
}

const FollowedCollections = ({ collectionsStatus, collections }: FollowedCollectionsProps) => {
  const { t } = useTranslation();
  const contentPadding = useResponsivePadding();
  const { router } = useRouter();

  return (
    <Box data-testid='followed-collections-page'>
      <MasterLayout isNewMerklistePage={true}>
        <CollectionsAppLayout
          title={t('Saved')}
          tabs={
            <CollectionsTabs
              activeTab={routes.followed.root}
              isNewDesignEnabled={true}
            />
          }
          isSearchPageContainer={true}
          headerButton={
            <FollowedCollectionsHeaderButton onClickButton={() => router.push(`/${routes.curatedCollections.root}`)}/>
          }
        >
          <Box sx={{ padding: contentPadding }}>
            {
              (collectionsStatus === AsyncActionStatus.LOADING || collections?.length === 0) ?
                <FollowedCollectionsEmptyState /> :
                <FollowedCollectionsList collections={collections} />
            }
          </Box>
        </CollectionsAppLayout>
      </MasterLayout>
    </Box>
  );
};

export default FollowedCollections;
